import { render, staticRenderFns } from "./SingleSelectFilter.vue?vue&type=template&id=63afe208"
import script from "./SingleSelectFilter.vue?vue&type=script&lang=js"
export * from "./SingleSelectFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports